import React from "react"
import "./step4-register.scss"
import Button from "../../../shared/components/atoms/button/button"
import iconEye from "../../../assets/images/eye.svg"
import iconEyeClose from "../../../assets/images/eye_close.svg"
import { withPrefix } from "gatsby"
import { registerStepDatalayer } from "../../../utils/registerDatalayer"

const Step4Register = props => {
  if (props.userData) {
    if (props.userData.password === null) {
      window.location.href = withPrefix("/correo")
    }
  } else {
    if (typeof window !== "undefined") {
      window.location.href = withPrefix("/correo")
    }
  }

  //init pasword level secfurity
  const [levelSecurity, setLevelSecurity] = React.useState(() => {
    var numberSecurity = 0
    var val = props.userData ? props.userData.password : ""
    if (/[a-z]/.test(val)) {
      numberSecurity++
    }
    if (/[A-Z]/.test(val)) {
      numberSecurity++
    }
    if (/[0-9]/.test(val)) {
      numberSecurity++
    }
    if (/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(val)) {
      numberSecurity++
    }
    switch (numberSecurity) {
      case 1:
        return 1
      case 2:
        return 2
      case 3:
        return 2
      case 4:
        return 3

      default:
        return 1
    }
  })
  const [copylevelSecurity, setCopyLevelSecurity] = React.useState(() => {
    var numberSecurity = 0
    var val = props.userData ? props.userData.password : ""
    if (/[a-z]/.test(val)) {
      numberSecurity++
    }
    if (/[A-Z]/.test(val)) {
      numberSecurity++
    }
    if (/[0-9]/.test(val)) {
      numberSecurity++
    }
    if (/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(val)) {
      numberSecurity++
    }
    switch (numberSecurity) {
      case 1:
        return "Débil"
      case 2:
        return "Medio"
      case 3:
        return "Medio"
      case 4:
        return "Fuerte"

      default:
        return "Débil"
    }
  })
  const changePassword = e => {
    //(?=.*[0-9])(?![.\n])(?![*\s])(?=.*[A-Z])(?=.*[a-z]).
    if (e.target.value.length > 5) {
      var numberSecurity = 0
      var val = e.target.value
      if (/[a-z]/.test(val)) {
        numberSecurity++
      }
      if (/[A-Z]/.test(val)) {
        numberSecurity++
      }
      if (/[0-9]/.test(val)) {
        numberSecurity++
      }
      if (/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(val)) {
        numberSecurity++
      }
      switch (numberSecurity) {
        case 1:
          setLevelSecurity(1)
          setCopyLevelSecurity("Débil")
          break
        case 2:
          setLevelSecurity(2)
          setCopyLevelSecurity("Medio")
          break
        case 3:
          setLevelSecurity(2)
          setCopyLevelSecurity("Medio")
          break
        case 4:
          setLevelSecurity(3)
          setCopyLevelSecurity("Fuerte")
          break

        default:
          setLevelSecurity(1)
          setCopyLevelSecurity("Débil")
          break
      }
    } else {
      setLevelSecurity(1)
      setCopyLevelSecurity("Débil")
    }
    props.handleChange(e)
  }
  const [type, setType] = React.useState("password")
  return (
    <>
      <form onSubmit={props.handleSubmit(()=>{props.onSubmit();registerStepDatalayer({ category: "registro_4", label: "siguiente" })})}>
        <div className="f-step-register-form">
          <span className="f-step-register-form-error-generic">
            {Object.keys(props.errors).length > 0 &&
            props.errors.password.type === "required"
              ? "*Debes completar todos los campos"
              : ""}
          </span>
          <div className="f-step-register-form-item">
            <div>
              <label>¿QUÉ CONTRASEÑA QUIERES USAR?</label>
              <div className="f-form-eye">
                <img
                  className="f-form-eye-icon"
                  src={type === "text" ? iconEyeClose : iconEye}
                  onClick={() => {
                    if (type === "password") {
                      setType("text")
                    } else {
                      setType("password")
                    }
                  }}
                />
                <input
                  type={type}
                  name="password"
                  className={
                    props.errors.password
                      ? "f-form-password f-error-value"
                      : "f-form-password"
                  }
                  autoComplete="off"
                  id={"outlined-password"}
                  onChange={e => {
                    var newValue = e.target.value.replace(/ /g, "")
                    if (e.target.value[e.target.value.length - 1] === " ") {
                      props.setValue("password", e.target.value.slice(0, -1))
                    }
                    props.setValue("password", newValue)
                    changePassword(e)
                  }}
                  ref={props.register({
                    required: true,
                    pattern: /.{6,}$/,
                  })}
                />
              </div>
              <div className="f-step-register-form-item-seguritypw">
                <span className="active" />
                <span className={levelSecurity > 1 ? "active" : ""} />
                <span className={levelSecurity > 2 ? "active" : ""} />
                <p>{copylevelSecurity}</p>
              </div>
            </div>
          </div>
          <p className="f-step-register-copy">
            *La contraseña debe ser de mínimo 6 caracteres.
          </p>
          <br />
        </div>
        <div className="f-step-register-buttons">
          <Button
            className="new-primary-pink short f-btn-form-nextStep"
            title="Siguiente"
            type="submit"
          />
          <div
            className="f-step-register-buttons-back"
            onClick={e => {
              registerStepDatalayer({ category: "registro_4", label: "anterior" })
              props.hadleBack && props.hadleBack(e)
            }}
          >
            <Button
              className="new-primary-pink--outline short f-btn-form-prevStep"
              title="Anterior"
            />
          </div>
        </div>
      </form>
    </>
  )
}

export default Step4Register
